import styles from "./Portfolio.module.css";
import Card from "../../components/Card/Card";

// images
import secretWord from "../../assets/secret_word.png";
import miniBlog from "../../assets/mini_Blog.png";
import toDoList from "../../assets/to_do_list.png";
import calculator from "../../assets/calculator.png";
import imcCalculator from "../../assets/IMC_calculator.png";

import { useRef } from "react";

const Portfolio = () => {
  const carousel = useRef(null);

  const handleLeftClick = (e) => {
    e.preventDefault();
    carousel.current.scrollLeft -= carousel.current.offsetWidth + 8;
  };
  const handleRightClick = (e) => {
    e.preventDefault();
    carousel.current.scrollLeft += carousel.current.offsetWidth + 8;
  };

  return (
    <section className="section" id="portfolio">
      <h2 className="section__title">Portfolio</h2>
      <p className="section__subtitle">Meus melhores projetos</p>
      <div className={`${styles.carousel}`}>
        <button onClick={handleLeftClick}>
          <i className="uil uil-angle-left-b"></i>
        </button>
        <div ref={carousel}>
          <Card
            image={miniBlog}
            title="Mini Blog"
            tech="JavaScript, React, CSS e Firebase"
            description="Um site interativo e dinâmico para compartilhar momentos especiais por meio de imagens. Os usuários autenticados podem publicar posts com legendas e hashtags, tornando suas publicações mais envolventes e fáceis de serem encontradas."
            githubCode="https://github.com/Siqueira2/mini-blog"
            webView="https://mini-blog-smoky.vercel.app"
          />
          <Card
            image={secretWord}
            title="Secret Word"
            tech="JavaScript, React e CSS"
            description="É uma experiência envolvente e desafiadora onde o objetivo é encontrar a palavra correta. Descubra letra por letra, mas cuidado, você tem um número limitado de chances. Teste suas habilidades e divirta-se com uma variedade de categorias de palavras. "
            githubCode="https://github.com/Siqueira2/Secret_Word"
            webView="https://secret-word-liart.vercel.app"
          />
          <Card
            image={imcCalculator}
            title="IMC Calculator"
            tech="JavaScript, HTML e CSS"
            description="É uma aplicação para análise de saúde. Ao informar seu peso e altura, você obterá o seu Índice de Massa Corporal com precisão. Acompanhe sua condição física de forma estilizada, combinando funcionalidade e estética do neomorfismo."
            githubCode="https://github.com/Siqueira2/IMC_calculator"
            webView="https://siqueira2.github.io/IMC_calculator"
          />
          <Card
            image={calculator}
            title="Calculator"
            tech="JavaScript, HTML e CSS"
            description="Uma calculadora simples e funcional com um toque de elegância. Realiza operações matemáticas básicas de forma rápida e intuitiva. Além de apresentar a estética encantadora do glassmorfismo, com seus elementos translúcidos."
            githubCode="https://github.com/Siqueira2/Calculator"
            webView="https://siqueira2.github.io/Calculator"
          />
          <Card
            image={toDoList}
            title="To Do List"
            tech="JavaScript, HTML e CSS"
            description="Uma aplicação prática e versátil para gerenciar suas tarefas diárias. Adicione, edite e exclua tarefas com facilidade, mantendo-se organizado(a) e produtivo(a). Marque as tarefas como 'feitas' para acompanhar seu progresso. Projetada para simplificar sua rotina."
            githubCode="https://github.com/Siqueira2/To-Do-List"
            webView="https://siqueira2.github.io/To-Do-List/"
          />
        </div>
        <button onClick={handleRightClick}>
          <i className="uil uil-angle-right-b"></i>
        </button>
      </div>
    </section>
  );
};

export default Portfolio;
